// Checkout Policy Agreement JavaScript
// التحقق من موافقة المستخدم على السياسات قبل الدفع

class CheckoutPolicyAgreement {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupPolicyCheck());
    } else {
      this.setupPolicyCheck();
    }
  }

  setupPolicyCheck() {
    const policyCheckbox = document.querySelector('#policy-agreement-checkbox');
    const policyContainer = document.querySelector('.checkout-policy-agreement');
    
    if (!policyCheckbox || !policyContainer) {
      console.log('Policy agreement elements not found');
      return;
    }

    // Add event listener to checkbox
    policyCheckbox.addEventListener('change', () => {
      this.handlePolicyChange(policyContainer, policyCheckbox.checked);
    });

    // Override all form submissions
    this.overrideFormSubmissions(policyContainer, policyCheckbox);

    // Override all buy button clicks
    this.overrideBuyButtons(policyContainer, policyCheckbox);

    // Initial state
    this.handlePolicyChange(policyContainer, policyCheckbox.checked);
  }

  handlePolicyChange(container, isChecked) {
    if (isChecked) {
      container.classList.add('accepted');
      container.classList.remove('not-accepted');
      this.hideError(container);
    } else {
      container.classList.remove('accepted');
      container.classList.add('not-accepted');
    }
  }

  overrideFormSubmissions(container, checkbox) {
    // Override all form submissions on the page
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (form && form.action && form.action.includes('/cart/add')) {
        if (!checkbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          this.showError(container);
          return false;
        }
      }
    }, true);
  }

  overrideBuyButtons(container, checkbox) {
    // Find all possible buy buttons
    const buyButtons = document.querySelectorAll(`
      [data-testid="product-form-submit"],
      .product-form__buttons button[type="submit"],
      .btn--primary[type="submit"],
      button[type="submit"],
      .product-form__buttons button,
      .btn--primary,
      .btn--secondary,
      [data-testid="buy-buttons"] button,
      .dynamic-checkout__content button,
      .shopify-payment-button button,
      .shopify-payment-button__button,
      .dynamic-checkout__content .shopify-payment-button__button,
      [data-testid="buy-buttons"] .shopify-payment-button__button
    `);

    // Add validation to all buy buttons
    buyButtons.forEach(button => {
      this.addValidationToButton(button, container, checkbox);
    });

    // Also check for dynamically added buttons
    this.observeDynamicButtons(container, checkbox);
  }

  addValidationToButton(button, container, checkbox) {
    // Store original onclick if it exists
    const originalOnclick = button.onclick;
    
    // Override onclick
    button.onclick = (e) => {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        this.showError(container);
        return false;
      }
      // Call original onclick if validation passes
      if (originalOnclick) {
        return originalOnclick.call(button, e);
      }
    };

    // Also add event listener as backup
    button.addEventListener('click', (e) => {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        this.showError(container);
        return false;
      }
    });
  }

  observeDynamicButtons(container, checkbox) {
    // Use MutationObserver to watch for new buttons
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const buttons = node.matches && node.matches('button') 
              ? [node] 
              : node.querySelectorAll ? node.querySelectorAll('button') : [];
            
            buttons.forEach(button => {
              if (this.isBuyButton(button)) {
                this.addValidationToButton(button, container, checkbox);
              }
            });
          }
        });
      });
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  isBuyButton(button) {
    const text = button.textContent.toLowerCase();
    const classes = button.className.toLowerCase();
    
    return (
      text.includes('buy') ||
      text.includes('add to cart') ||
      text.includes('purchase') ||
      text.includes('checkout') ||
      classes.includes('btn--primary') ||
      classes.includes('product-form') ||
      button.type === 'submit'
    );
  }

  showError(container) {
    this.hideError(container);
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'policy-error show';
    errorDiv.style.color = '#dc3545';
    errorDiv.style.fontWeight = '600';
    errorDiv.style.backgroundColor = '#f8d7da';
    errorDiv.style.border = '1px solid #f5c6cb';
    errorDiv.style.borderRadius = '4px';
    errorDiv.style.padding = '0.5rem';
    errorDiv.style.marginTop = '0.5rem';
    
    // Get language from HTML lang attribute
    const isArabic = document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl';
    errorDiv.textContent = isArabic 
      ? 'يرجى الموافقة على سياسة الاسترجاع والشحن والتوصيل قبل المتابعة'
      : 'Please agree to the return, shipping and delivery policy before proceeding';
    
    container.appendChild(errorDiv);
    
    // Scroll to error
    container.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  hideError(container) {
    const existingError = container.querySelector('.policy-error');
    if (existingError) {
      existingError.remove();
    }
  }
}

// Initialize the policy agreement
new CheckoutPolicyAgreement();
